import styled, { css } from 'styled-components';
import { getSchemaVariant } from '../../../foundation/theme/palette.utils';
import { getRadius } from '../../../foundation/theme/shape.utils';
import { getSpace } from '../../../foundation/theme/space.utils';
import { BUTTON_PADDING_SIZES } from './Button.constants';
// styled-components.
// -----------------------------------------------------------------------------
export const ButtonRoot = styled.button `
  ${({ mode, schema, size, theme, isLoading, variant }) => {
    const { default: defaultColor, disabled: disabledColor, focus: focusColor, hover: focusHover, pressed: pressedHover } = getSchemaVariant({ mode, schema, theme, variant });
    return css `
      cursor: pointer;

      /* Box model */
      align-items: center;
      display: inline-flex;
      gap: ${getSpace('s')};
      justify-content: center;

      /* Colors */
      background-color: ${defaultColor.background};
      border: 2px solid ${defaultColor.border};
      color: ${defaultColor.foreground};

      svg {
        color: ${defaultColor.foregroundAlt};
      }

      /* Radius */
      border-radius: ${getRadius(theme, 'm')};

      /* Misc */
      transition: 0.3s;
      cursor: pointer;

      /* Spacing */
      padding-bottom: ${getSpace(BUTTON_PADDING_SIZES[size].vertical)};
      padding-left: ${getSpace(BUTTON_PADDING_SIZES[size].horizontal)};
      padding-right: ${getSpace(BUTTON_PADDING_SIZES[size].horizontal)};
      padding-top: ${getSpace(BUTTON_PADDING_SIZES[size].vertical)};

      /* isLoading */
      ${isLoading &&
        css `
        pointer-events: none;

        .button__icon--loading svg {
          color: ${defaultColor.active || defaultColor.foregroundAlt};
        }
      `}

      /* Status: Disabled. */
      &:disabled {
        background-color: ${disabledColor.background};
        border: 2px solid ${disabledColor.border};
        color: ${disabledColor.foreground};
        cursor: not-allowed;

        svg {
          color: ${disabledColor.foregroundAlt};
        }

        &:hover {
          background-color: ${disabledColor.background};
          border: 2px solid ${disabledColor.border};
          color: ${disabledColor.foreground};

          svg {
            color: ${disabledColor.foregroundAlt};
          }
        }
      }

      /* Status: Focus. */
      &:focus {
        background-color: ${focusColor.background};
        border: 2px solid ${focusColor.border};
        color: ${focusColor.foreground};

        svg {
          color: ${focusColor.foregroundAlt};
        }
      }

      /* Status: Hover. */
      &:hover {
        background-color: ${focusHover.background};
        border: 2px solid ${focusHover.border};
        color: ${focusHover.foreground};

        svg {
          color: ${focusHover.foregroundAlt};
        }
      }

      /* Status: Pressed. */
      &:active {
        background-color: ${pressedHover.background};
        border: 2px solid ${pressedHover.border};
        color: ${pressedHover.foreground};

        svg {
          color: ${pressedHover.foregroundAlt};
        }
      }
    `;
}}
`;
export const ButtonText = styled.span `
  white-space: nowrap;
`;
//# sourceMappingURL=Button.styled.js.map